/**
 * Soft studio IBL so meshStandard metals (rails) read as aluminum instead of flat plastic.
 * Uses Three's offline RoomEnvironment — no HDR network fetch.
 */
import { useLayoutEffect, type FC } from 'react';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';

type Props = {
  /** Multiplier on scene.environmentIntensity (Three r163+). */
  intensity?: number;
};

const SceneEnvironment3D: FC<Props> = ({ intensity = 1.15 }) => {
  const { gl, scene } = useThree();

  useLayoutEffect(() => {
    const webgl = gl as THREE.WebGLRenderer;
    if (!webgl?.state?.buffers) {
      return;
    }
    const pmrem = new THREE.PMREMGenerator(gl);
    const envScene = new RoomEnvironment();
    const { texture } = pmrem.fromScene(envScene, 0.04);
    const prevEnv = scene.environment;
    const prevIntensity = scene.environmentIntensity;
    scene.environment = texture;
    scene.environmentIntensity = intensity;

    return () => {
      scene.environment = prevEnv;
      scene.environmentIntensity = prevIntensity;
      texture.dispose();
      pmrem.dispose();
      envScene.dispose();
    };
  }, [gl, scene, intensity]);

  return null;
};

export default SceneEnvironment3D;
